import { getCustomQueries } from '@/helpers/queryHelper';
import {
  CLEAR_DROPDOWN_DATA,
  GET_COURSE_DROPDOWN,
  GET_COURSE_DROPDOWN_FAILED,
  GET_COURSE_DROPDOWN_SUCCEEDED,
  GET_SUBJECT_CONTENT_DROPDOWN,
  GET_SUBJECT_CONTENT_DROPDOWN_FAILED,
  GET_SUBJECT_CONTENT_DROPDOWN_SUCCEEDED,
  GET_USER_DROPDOWN,
  GET_USER_DROPDOWN_CLIENT,
  GET_USER_DROPDOWN_CLIENT_FAILED,
  GET_USER_DROPDOWN_CLIENT_SUCCEEDED,
  GET_USER_DROPDOWN_FAILED,
  GET_USER_DROPDOWN_SUCCEEDED,
  SET_DROPDOWN_DATA,
  SET_DROPDOWN_EDIT_DATA,
} from '.';

export const getUserDropdown = ({ data }) => {
  let query = getCustomQueries(data);
  return {
    type: GET_USER_DROPDOWN,
    payload: {
      url: `drop_down/user?${query}`,
      onSuccess: GET_USER_DROPDOWN_SUCCEEDED,
      onFailure: GET_USER_DROPDOWN_FAILED,
    },
  };
};

export const getClientDropdown = ({ data }) => {
  let query = getCustomQueries(data);
  return {
    type: GET_USER_DROPDOWN_CLIENT,
    payload: {
      url: `drop_down/user?user_type=client&${query}`,
      onSuccess: GET_USER_DROPDOWN_CLIENT_SUCCEEDED,
      onFailure: GET_USER_DROPDOWN_CLIENT_FAILED,
    },
  };
};

export const getCourseDropdown = ({ data }) => {
  let query = getCustomQueries(data);
  return {
    type: GET_COURSE_DROPDOWN,
    payload: {
      url: `course-drop-down?${query}`,
      onSuccess: GET_COURSE_DROPDOWN_SUCCEEDED,
      onFailure: GET_COURSE_DROPDOWN_FAILED,
    },
  };
};

export const getSubjectContentDropdown = ({ courseId }) => {
  return {
    type: GET_SUBJECT_CONTENT_DROPDOWN,
    payload: {
      url: `get-subject-dropdown?course=${courseId}`,
      onSuccess: GET_SUBJECT_CONTENT_DROPDOWN_SUCCEEDED,
      onFailure: GET_SUBJECT_CONTENT_DROPDOWN_FAILED,
    },
  };
};

export const clearDropDownData = (payload) => {
  return {
    type: CLEAR_DROPDOWN_DATA,
    payload,
  };
};

export const setDropDownData = (payload) => {
  return {
    type: SET_DROPDOWN_DATA,
    payload,
  };
};
export const setDropEditDownData = (payload) => {
  return {
    type: SET_DROPDOWN_EDIT_DATA,
    payload,
  };
};
